/* Albatross x Hemisphere — product-page block behaviours (snippets/hm-pb-*.liquid).
   Works with Smile's own <product-form>, <variant-radios>/<variant-selects>, <quantity-input> and cart drawer. */
(() => {
  if (window.HMPB) return;

  /* ------------------------------------------------------------------ helpers */
  const json = (el) => { try { return JSON.parse(el.textContent); } catch (e) { return null; } };
  const q = (sel, root = document) => root.querySelector(sel);
  const qa = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const esc = (s) => (window.CSS && CSS.escape ? CSS.escape(s) : String(s).replace(/"/g, '\\"'));

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const fmt = format || window.HMPB_MONEY_FORMAT || '{{amount}}';
    const amount = Number(cents) / 100;
    const group = (num, decimals, thousands, dec) => {
      const fixed = num.toFixed(decimals);
      const [whole, frac] = fixed.split('.');
      const w = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return frac ? w + dec + frac : w;
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
      switch (key) {
        case 'amount_no_decimals': return group(amount, 0, ',', '.');
        case 'amount_with_comma_separator': return group(amount, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(amount, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(amount, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return group(amount, 0, ' ', '.');
        case 'amount_with_space_separator': return group(amount, 2, ' ', ',');
        case 'amount_with_period_and_space_separator': return group(amount, 2, ' ', '.');
        default: return group(amount, 2, ',', '.');
      }
    });
  }
  // Smile's constants.js declares PUB_SUB_EVENTS with const (global lexical binding, not a window property)
  const decode = (s) => { const t = document.createElement('textarea'); t.innerHTML = s || ''; return t.value; };

  function findVariant(variants, options) {
    return (variants || []).find((v) => options.every((o, i) => v.options[i] === o));
  }

  function cartEl() { return document.querySelector('cart-notification') || document.querySelector('cart-drawer'); }

  function setLoading(btn, on) {
    if (!btn) return;
    btn.classList.toggle('is-loading', on);
    btn.classList.toggle('loading', on);
    if (on) btn.setAttribute('aria-disabled', 'true'); else btn.removeAttribute('aria-disabled');
  }

  function showFormError(form, msg) {
    const pf = form && form.closest('product-form');
    if (pf && typeof pf.handleErrorMessage === 'function') { pf.handleErrorMessage(msg || false); return true; }
    return false;
  }

  /* Add a list of {id, quantity, properties} to the cart and show it in Smile's cart drawer/notification. */
  function addItems(items, opts = {}) {
    const merged = [];
    items.forEach((it) => {
      if (!it || !it.id) return;
      const hasProps = it.properties && Object.keys(it.properties).length;
      const same = !hasProps && merged.find((m) => String(m.id) === String(it.id) && !m.properties);
      if (same) same.quantity += it.quantity || 1;
      else merged.push(Object.assign({ quantity: 1 }, it, { id: Number(it.id) }));
    });
    if (!merged.length) return Promise.resolve(null);
    const cart = cartEl();
    const body = { items: merged };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }
    setLoading(opts.button, true);
    const url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body),
    })
      .then((r) => r.json())
      .then((res) => {
        if (res.status) {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartError, { source: 'hm-pb', errors: res.errors || res.description, message: res.message });
          if (!(opts.form && showFormError(opts.form, res.description)) && opts.onError) opts.onError(res.description || res.message);
          return res;
        }
        if (opts.skipCart) { window.location = '/checkout'; return res; }
        if (!cart) { window.location = (window.routes && window.routes.cart_url) || '/cart'; return res; }
        if (res.items && res.items[0]) { res.key = res.items[0].key; res.id = res.items[0].variant_id; }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hm-pb', productVariantId: merged[0].id, cartData: res });
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        cart.renderContents(res);
        return res;
      })
      .catch((e) => { console.error(e); if (opts.onError) opts.onError(); })
      .finally(() => setLoading(opts.button, false));
  }

  /* ------------------------------------------------------------------ dynamic dates */
  if (!customElements.get('hm-dates')) {
    customElements.define('hm-dates', class extends HTMLElement {
      connectedCallback() { this.render(); }
      render() {
        const days = (this.dataset.days || '').split(',').map((s) => s.trim());
        const months = (this.dataset.months || '').split(',').map((s) => s.trim());
        const fmt = this.dataset.format;
        const pad = (n) => String(n).padStart(2, '0');
        const ord = (d) => ([1, 21, 31].includes(d) ? 'st' : [2, 22].includes(d) ? 'nd' : [3, 23].includes(d) ? 'rd' : 'th');
        const label = (offset) => {
          const dt = new Date();
          dt.setDate(dt.getDate() + (parseInt(offset, 10) || 0));
          const d = dt.getDate(); const m = dt.getMonth();
          const day = days[(dt.getDay() + 6) % 7] || ''; const month = months[m] || '';
          switch (fmt) {
            case 'day_dd_mm': return `${day}, ${d}. ${month}`;
            case 'mm_dd': return `${month} ${d}${ord(d)}`;
            case 'dd_mm': return `${d}. ${month}`;
            case 'dd_mm_no_dot': return `${d} ${month}`;
            case 'day_dd_mm_numeric': return `${day}, ${pad(d)}. ${pad(m + 1)}.`;
            case 'dd_mm_numeric': return `${pad(d)}. ${pad(m + 1)}.`;
            default: return `${day}, ${month} ${d}${ord(d)}`;
          }
        };
        qa('[data-hm-text]', this).forEach((el) => {
          const tpl = el.dataset.hmText;
          el.innerHTML = tpl.split('[start_date]').join(label(el.dataset.min)).split('[end_date]').join(label(el.dataset.max));
        });
      }
    });
  }

  /* ------------------------------------------------------------------ small slider (reviews) */
  if (!customElements.get('hm-pb-slider')) {
    customElements.define('hm-pb-slider', class extends HTMLElement {
      connectedCallback() {
        if (this._init) { // re-connected: restore what disconnectedCallback removed, don't re-bind element listeners
          window.addEventListener('resize', this._onResize);
          this.startTimer();
          return;
        }
        this._init = true;
        this.viewport = q('.hm-pb-slider__viewport', this);
        this.track = q('.hm-pb-slider__track', this);
        this.slides = qa('.hm-pb-slider__slide', this);
        this.dots = qa('.hm-pb-slider__dot', this);
        this.mode = this.dataset.mode || 'slide';
        this.index = 0;
        this.dots.forEach((d) => d.addEventListener('click', () => this.go(Number(d.dataset.index))));
        qa('.hm-pb-slider__arrow', this).forEach((a) => a.addEventListener('click', () => this.go(this.index + Number(a.dataset.dir))));
        let x0 = null;
        this.viewport.addEventListener('pointerdown', (e) => { x0 = e.clientX; });
        this.viewport.addEventListener('pointerup', (e) => { if (x0 === null) return; const dx = e.clientX - x0; x0 = null; if (Math.abs(dx) > 40) this.go(this.index + (dx < 0 ? 1 : -1)); });
        this._onResize = () => this.size();
        window.addEventListener('resize', this._onResize);
        this.startTimer();
        this.go(0);
        setTimeout(() => this.size(), 300);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        if (this._onResize) window.removeEventListener('resize', this._onResize);
      }
      startTimer() {
        clearInterval(this.timer);
        if (this.dataset.autoplay !== 'true') return;
        const ms = (parseFloat(this.dataset.speed) || 5) * 1000;
        this.timer = setInterval(() => { if (!this.matches(':hover')) this.go(this.index + 1, true); }, ms);
      }
      go(i, auto) {
        const n = this.slides.length;
        if (this.mode === 'slide' && !auto) i = Math.max(0, Math.min(n - 1, i));
        else i = ((i % n) + n) % n;
        this.index = i;
        if (this.mode !== 'fade') this.track.style.transform = `translateX(-${i * 100}%)`;
        this.slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
        this.dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
        if (window.HM && window.HM.pauseVideosIn) window.HM.pauseVideosIn(this);
        this.size();
      }
      size() { const s = this.slides[this.index]; if (s) this.viewport.style.height = s.offsetHeight + 'px'; }
    });
  }

  /* ------------------------------------------------------------------ clickable discount */
  if (!customElements.get('hm-discount')) {
    customElements.define('hm-discount', class extends HTMLElement {
      connectedCallback() {
        if (this._init) return; this._init = true;
        this.key = 'hm-discount-' + this.dataset.code;
        try { if (sessionStorage.getItem(this.key) === '1') this.dataset.state = 'applied'; } catch (e) {}
        q('.hm-pb-cd__btn', this).addEventListener('click', () => this.apply());
      }
      apply() {
        if (this.dataset.state !== 'idle') return;
        const err = q('.hm-pb-cd__error', this);
        this.dataset.state = 'loading'; err.hidden = true;
        fetch('/discount/' + encodeURIComponent(this.dataset.code), { credentials: 'same-origin' })
          .then((r) => { if (!r.ok) throw new Error(r.status); this.dataset.state = 'applied'; try { sessionStorage.setItem(this.key, '1'); } catch (e) {} })
          .catch(() => { this.dataset.state = 'idle'; err.hidden = false; });
      }
    });
  }

  /* ------------------------------------------------------------------ custom product field */
  if (!customElements.get('hm-field')) {
    customElements.define('hm-field', class extends HTMLElement {
      connectedCallback() {
        if (this._init) return; this._init = true;
        this.addEventListener('input', () => this.clear());
        this.addEventListener('change', () => this.clear());
      }
      get control() { return q('input:not([type="radio"]), textarea, select', this); }
      isValid() {
        if (this.dataset.required !== 'true') return true;
        const t = this.dataset.type;
        if (t === 'pills') return !!q('input[type="radio"]:checked', this);
        const c = this.control; return !!(c && c.value.trim() !== '');
      }
      showError() { this.classList.add('is-invalid'); const e = q('.hm-pb-field__error', this); if (e) e.hidden = false; }
      clear() { this.classList.remove('is-invalid'); const e = q('.hm-pb-field__error', this); if (e) e.hidden = true; }
      emptyControls() { return qa('input:not([type="radio"]), textarea', this).filter((c) => c.value.trim() === ''); }
    });
  }

  /* ------------------------------------------------------------------ secondary variant dropdowns */
  function bindDropdowns(root, onVariant) {
    const box = q('.hm-pb-vsel', root);
    if (!box) return;
    const dataEl = q('[data-hm-variants]', box);
    const variants = dataEl ? json(dataEl) : [];
    box.addEventListener('change', () => {
      const opts = qa('select', box).map((s) => s.value);
      const v = findVariant(variants, opts);
      onVariant(v || null);
    });
  }

  /* ------------------------------------------------------------------ product upsell */
  if (!customElements.get('hm-upsell')) {
    customElements.define('hm-upsell', class extends HTMLElement {
      connectedCallback() {
        if (this._init) return; this._init = true;
        const style = this.dataset.style;
        const ctrl = q('.hm-pb-ups__ctrl', this);
        if (style !== 'add_button') {
          const toggle = (e) => {
            if (e.target.closest('.hm-pb-vsel, a')) return;
            this.dataset.selected = this.dataset.selected === 'true' ? 'false' : 'true';
            if (ctrl) ctrl.setAttribute('aria-pressed', this.dataset.selected);
          };
          if (this.dataset.toggleOn === 'container') this.addEventListener('click', toggle);
          else if (ctrl) ctrl.addEventListener('click', toggle);
        } else {
          const btn = q('.hm-pb-ups__add', this);
          btn && btn.addEventListener('click', () => addItems([{ id: this.dataset.id, quantity: 1 }], { button: btn }));
        }
        bindDropdowns(this, (v) => {
          const add = q('.hm-pb-ups__add', this);
          if (!v) { if (add) add.disabled = true; return; }
          this.dataset.id = v.id;
          if (add) add.disabled = !v.available;
          if (this.dataset.updatePrices === 'true') {
            const price = Math.max(0, v.price * parseFloat(this.dataset.pctLeft || 1) - parseFloat(this.dataset.fixed || 0));
            const compare = Math.max(v.compare_at_price || 0, v.price);
            const fmt = decode(this.dataset.moneyFormat);
            qa('.hm-pb-ups__now', this).forEach((el) => { el.textContent = formatMoney(Math.round(price), fmt); });
            qa('.hm-pb-ups__was', this).forEach((el) => { el.textContent = formatMoney(compare, fmt); el.hidden = !(compare > price); });
          }
        });
      }
    });
  }

  /* ------------------------------------------------------------------ bundle offer */
  if (!customElements.get('hm-bundle')) {
    customElements.define('hm-bundle', class extends HTMLElement {
      connectedCallback() {
        if (this._init) return; this._init = true;
        this.fmt = decode(this.dataset.moneyFormat);
        qa('.hm-pb-bundle__item', this).forEach((item) => {
          bindDropdowns(item, (v) => {
            if (!v) return;
            item.dataset.id = v.id;
            if (item.dataset.variantImage === 'true' && v.featured_image) {
              const img = q('.hm-pb-bundle__img', item);
              if (img) { img.src = v.featured_image.src + (v.featured_image.src.includes('?') ? '&' : '?') + 'width=300'; img.removeAttribute('srcset'); }
            }
            if (this.dataset.updatePrices === 'true') {
              item.dataset.price = Math.max(0, Math.round(v.price * parseFloat(item.dataset.pctLeft || 1) - parseFloat(item.dataset.fixed || 0)));
              item.dataset.compare = Math.max(v.compare_at_price || 0, v.price);
              this.paintItem(item);
              this.paintTotals();
            }
          });
        });
        const atc = q('.hm-pb-bundle__atc', this);
        if (atc) atc.addEventListener('click', () => {
          const err = q('.hm-pb-bundle__error', this);
          if (err) err.hidden = true;
          let items = this.items();
          if (this.dataset.includeUpsells === 'true') items = items.concat(collectUpsells(this.dataset.form));
          addItems(items, { button: atc, onError: (m) => { if (err) { q('.product-form__error-message', err).textContent = m || 'Error'; err.hidden = false; } } });
        });
      }
      items() { return qa('.hm-pb-bundle__item', this).map((i) => ({ id: i.dataset.id, quantity: 1 })); }
      paintItem(item) {
        const p = Number(item.dataset.price); const c = Number(item.dataset.compare);
        qa('.hm-pb-bundle__now', item).forEach((el) => { el.textContent = p === 0 && this.dataset.freeText ? this.dataset.freeText : formatMoney(p, this.fmt); });
        qa('.hm-pb-bundle__was', item).forEach((el) => { el.textContent = formatMoney(c, this.fmt); el.hidden = !(c > p); });
      }
      paintTotals() {
        const items = qa('.hm-pb-bundle__item', this);
        let total = items.reduce((s, i) => s + Number(i.dataset.price), 0);
        const compare = items.reduce((s, i) => s + Number(i.dataset.compare), 0);
        total = Math.max(0, Math.round(total * parseFloat(this.dataset.totalPctLeft || 1) - parseFloat(this.dataset.totalFixed || 0)));
        const now = q('.hm-pb-bundle__total-now', this); const was = q('.hm-pb-bundle__total-was', this);
        if (now) now.textContent = formatMoney(total, this.fmt);
        if (was) { was.textContent = formatMoney(compare, this.fmt); was.hidden = !(compare > total); }
      }
    });
  }

  /* ------------------------------------------------------------------ quantity gifts */
  function currentQuantity(formId) {
    const form = document.getElementById(formId);
    const input = q(`input[name="quantity"][form="${esc(formId)}"]`) || (form && q('input[name="quantity"]', form));
    const n = input ? parseInt(input.value, 10) : 1;
    return Number.isFinite(n) && n > 0 ? n : 1;
  }
  if (!customElements.get('hm-gifts')) {
    customElements.define('hm-gifts', class extends HTMLElement {
      connectedCallback() {
        if (this._init) return; this._init = true;
        this.update = this.update.bind(this);
        this.onDoc = (e) => { if (e.target && e.target.name === 'quantity') this.update(); };
        this.onClick = () => setTimeout(this.update, 0);
        document.addEventListener('change', this.onDoc);
        document.addEventListener('input', this.onDoc);
        document.addEventListener('click', this.onClick);
        this.update();
      }
      disconnectedCallback() {
        document.removeEventListener('change', this.onDoc);
        document.removeEventListener('input', this.onDoc);
        document.removeEventListener('click', this.onClick);
        this._init = false;
      }
      update() {
        const qty = currentQuantity(this.dataset.form);
        qa('.hm-pb-gift', this).forEach((g) => { g.dataset.unlocked = String(qty >= (parseInt(g.dataset.quantity, 10) || 1)); });
      }
      unlocked() { return qa('.hm-pb-gift[data-unlocked="true"]', this).map((g) => g.dataset.id).filter(Boolean); }
    });
  }

  /* ------------------------------------------------------------------ sticky add to cart */
  if (!customElements.get('hm-sticky-atc')) {
    customElements.define('hm-sticky-atc', class extends HTMLElement {
      connectedCallback() {
        if (this.parentElement !== document.body) {
          // escape transformed/animated ancestors so position:fixed is relative to the viewport
          document.querySelectorAll(`hm-sticky-atc[data-section="${esc(this.dataset.section)}"]`).forEach((el) => { if (el !== this) el.remove(); });
          document.body.appendChild(this);
          return;
        }
        if (this._init) return; this._init = true;
        this.formId = this.dataset.form;
        this.fmt = decode(this.dataset.moneyFormat);
        const dataEl = q('[data-hm-variants]', this);
        this.variants = dataEl ? json(dataEl) || [] : [];
        this.btn = q('.hm-sticky__btn', this);
        this.err = q('.hm-sticky__error', this);
        this.label = this.btn ? this.btn.dataset.label : '';
        document.body.classList.add('hm-has-sticky');
        this.measure = () => document.body.style.setProperty('--hm-sticky-h', this.offsetHeight + 'px');
        this.measure();
        window.addEventListener('resize', this.measure);

        // keep in sync with Smile's variant picker (it writes the variant id into the form and fires "change")
        this.onChange = (e) => {
          const t = e.target;
          if (!t || t.name !== 'id') return;
          const f = t.form || t.closest('form');
          if (f && f.getAttribute('id') === this.formId) this.setVariant(t.value);
        };
        document.addEventListener('change', this.onChange);
        const idInput = this.idInput();
        if (idInput) this.setVariant(idInput.value);

        // sticky picker -> drive Smile's main picker (fallback: write the id directly)
        const combined = q('[data-hm-combined]', this);
        if (combined) combined.addEventListener('change', () => {
          const v = this.variants.find((x) => String(x.id) === combined.value);
          if (v) this.pickMain(v.options, v.id);
        });
        const separate = qa('[data-hm-option]', this);
        separate.forEach((s) => s.addEventListener('change', () => {
          const opts = separate.map((x) => x.value);
          const v = findVariant(this.variants, opts);
          this.pickMain(opts, v ? v.id : null);
          if (!v) this.paintUnavailable();
        }));

        if (this.btn) this.btn.addEventListener('click', (e) => this.onClick(e));
        this.subs = [];
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.subs.push(subscribe(PUB_SUB_EVENTS.cartUpdate, () => setLoading(this.btn, false)));
          this.subs.push(subscribe(PUB_SUB_EVENTS.cartError, () => setLoading(this.btn, false)));
        }

        if (this.dataset.afterScroll === 'true') {
          this.onScroll = () => {
            if (this._raf) return;
            this._raf = requestAnimationFrame(() => {
              this._raf = null;
              const ref = this.anchor();
              const past = ref ? ref.getBoundingClientRect().bottom < 0 : window.scrollY > 400;
              this.classList.toggle('hm-sticky--hidden', !past);
            });
          };
          window.addEventListener('scroll', this.onScroll, { passive: true });
          this.onScroll();
        }
      }
      disconnectedCallback() {
        if (!this._init) return;
        document.removeEventListener('change', this.onChange);
        window.removeEventListener('resize', this.measure);
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
        (this.subs || []).forEach((u) => typeof u === 'function' && u());
        if (!document.querySelector('hm-sticky-atc')) document.body.classList.remove('hm-has-sticky');
        this._init = false;
      }
      form() { return document.getElementById(this.formId); }
      idInput() { const f = this.form(); return f ? q('[name="id"]', f) : null; }
      anchor() {
        const f = this.form();
        return (f && q('[type="submit"]', f)) || document.getElementById('ProductSubmitButton-' + this.dataset.section) || document.getElementById('ProductInfo-' + this.dataset.section);
      }
      pickMain(options, id) {
        const sec = this.dataset.section;
        const picker = document.getElementById('variant-radios-' + sec) || document.getElementById('variant-selects-' + sec);
        if (picker) {
          const groups = qa('.product-form__input', picker);
          let last = null;
          options.forEach((val, i) => {
            const g = groups[i]; if (!g) return;
            const radio = qa('input[type="radio"]', g).find((r) => r.value === val);
            const select = q('select', g);
            if (radio) { radio.checked = true; last = radio; }
            else if (select) { select.value = val; last = select; }
          });
          if (last) { last.dispatchEvent(new Event('change', { bubbles: true })); return; }
        }
        const input = this.idInput();
        if (input && id) { input.value = id; input.dispatchEvent(new Event('change', { bubbles: true })); }
        else if (id) this.setVariant(id);
      }
      setVariant(id) {
        const v = this.variants.find((x) => String(x.id) === String(id));
        this.current = v ? v.id : id;
        if (!v) return;
        const now = q('.hm-sticky__now', this); const was = q('.hm-sticky__was', this);
        const badge = q('.hm-sticky__badge', this); const pct = q('.hm-sticky__pct', this);
        if (now) now.textContent = formatMoney(v.price, this.fmt);
        const sale = v.compare_at_price && v.compare_at_price > v.price;
        if (was) { was.hidden = !sale; if (sale) was.textContent = formatMoney(v.compare_at_price, this.fmt); }
        if (badge) { badge.hidden = !sale; if (sale && pct) pct.textContent = Math.round(((v.compare_at_price - v.price) * 100) / v.compare_at_price); }
        qa('.hm-sticky__btn-price', this).forEach((el) => { el.textContent = formatMoney(v.price, this.fmt) + ' • '; });
        const img = q('.hm-sticky__img', this);
        if (img && v.featured_image && v.featured_image.src) { img.src = v.featured_image.src + (v.featured_image.src.includes('?') ? '&' : '?') + 'width=200'; img.removeAttribute('srcset'); }
        const combined = q('[data-hm-combined]', this); if (combined) combined.value = String(v.id);
        qa('[data-hm-option]', this).forEach((s, i) => { if (v.options[i] !== undefined) s.value = v.options[i]; });
        if (this.dataset.mode === 'cart' && this.btn) {
          this.btn.disabled = !v.available;
          const l = q('.hm-sticky__btn-label', this);
          if (l) l.textContent = v.available ? this.label : this.dataset.soldOut;
        }
      }
      paintUnavailable() {
        if (this.dataset.mode !== 'cart' || !this.btn) return;
        this.btn.disabled = true;
        const l = q('.hm-sticky__btn-label', this); if (l) l.textContent = this.dataset.unavailable;
      }
      onClick(e) {
        if (this.err) this.err.hidden = true;
        if (this.dataset.mode !== 'cart') {
          e.preventDefault();
          const target = (this.dataset.target || '').split(',').map((s) => s.trim()).filter(Boolean).map((s) => { try { return q(s); } catch (x) { return null; } }).find(Boolean);
          (target || document.getElementById('ProductInfo-' + this.dataset.section) || document.body).scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        const form = this.form();
        if (!form) {
          // no buy-buttons block on the page: add the current variant directly
          e.preventDefault();
          addItems([{ id: this.current, quantity: 1 }].concat(collectExtras(this.formId).items.map((id) => ({ id, quantity: 1 }))), { button: this.btn, onError: (m) => this.error(m) });
          return;
        }
        setLoading(this.btn, true);
        clearTimeout(this._t); this._t = setTimeout(() => setLoading(this.btn, false), 6000);
      }
      error(msg) { if (this.err && msg) { this.err.textContent = msg; this.err.hidden = false; } setLoading(this.btn, false); }
    });
  }

  /* ------------------------------------------------------------------ sizing chart placement */
  function placeSizingCharts(root = document) {
    qa('.hm-pb-size[data-append]', root).forEach((wrap) => {
      const mode = wrap.dataset.append || 'none';
      const m = mode.match(/^option_(\d)_(label|under)_container$/);
      if (!m || wrap.dataset.placed) return;
      const sec = wrap.dataset.section;
      const picker = document.getElementById('variant-radios-' + sec) || document.getElementById('variant-selects-' + sec);
      if (!picker) return;
      const group = qa('.product-form__input', picker)[Number(m[1]) - 1];
      if (!group) return;
      wrap.dataset.placed = 'true';
      wrap.classList.add('hm-pb-size--appended');
      if (m[2] === 'under') { wrap.classList.remove('hm-pb-size--appended'); group.after(wrap); return; }
      const label = q('legend, label.form__label', group);
      if (label) label.after(wrap); else group.prepend(wrap);
    });
  }

  /* ------------------------------------------------------------------ extras for the main Add to cart */
  function collectUpsells(formId) {
    return qa(`hm-upsell[data-form="${esc(formId)}"][data-selected="true"]`).filter((u) => u.dataset.style !== 'add_button').map((u) => ({ id: u.dataset.id, quantity: 1 }));
  }
  function collectExtras(formId) {
    const out = { items: [], bundle: null };
    const bundle = q(`hm-bundle[data-type="main"][data-form="${esc(formId)}"]`);
    if (bundle && bundle.items().length) out.bundle = bundle.items();
    out.items = collectUpsells(formId).map((u) => u.id);
    const gifts = q(`hm-gifts[data-form="${esc(formId)}"]`);
    if (gifts && !out.bundle) out.items = out.items.concat(gifts.unlocked());
    return out;
  }

  document.addEventListener('submit', (e) => {
    const form = e.target;
    // note: form.id would return the <input name="id"> element, so always read the attribute
    const formId = form instanceof HTMLFormElement ? form.getAttribute('id') : null;
    if (!formId || !q('[name="id"]', form)) return;
    if (form.getAttribute('data-type') !== 'add-to-cart-form' && !formId.startsWith('product-form-')) return;

    // 1. required custom fields
    const fields = qa(`hm-field[data-form="${esc(formId)}"]`);
    const invalid = fields.filter((f) => typeof f.isValid === 'function' && !f.isValid());
    if (invalid.length) {
      e.preventDefault(); e.stopImmediatePropagation();
      invalid.forEach((f) => f.showError());
      const msg = invalid[0].dataset.atcError;
      showFormError(form, msg);
      const sticky = q(`hm-sticky-atc[data-form="${esc(formId)}"]`);
      if (sticky) { setLoading(sticky.btn, false); if (invalid[0].dataset.stickyError === 'true') sticky.error(msg); }
      invalid[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    // empty optional properties are not sent
    fields.forEach((f) => (typeof f.emptyControls === 'function' ? f.emptyControls() : []).forEach((c) => { c.disabled = true; setTimeout(() => { c.disabled = false; }, 0); }));

    // 2. bundle (main) / upsells / gifts -> one multi-item add
    const extras = collectExtras(formId);
    if (!extras.bundle && !extras.items.length) return; // Smile's product-form handles it as usual
    e.preventDefault(); e.stopImmediatePropagation();
    const fd = new FormData(form);
    const props = {};
    fd.forEach((v, k) => { const m = k.match(/^properties\[(.+)\]$/); if (m && v !== '') props[m[1]] = v; });
    let items;
    if (extras.bundle) items = extras.bundle.map((i) => Object.assign({}, i, Object.keys(props).length ? { properties: props } : {}));
    else {
      const main = { id: fd.get('id'), quantity: parseInt(fd.get('quantity'), 10) || 1 };
      if (Object.keys(props).length) main.properties = props;
      if (fd.get('selling_plan')) main.selling_plan = fd.get('selling_plan');
      items = [main];
    }
    items = items.concat(extras.items.map((id) => ({ id, quantity: 1 })));
    const pf = form.closest('product-form');
    const btn = (pf && q('[type="submit"]', pf)) || q('[type="submit"]', form);
    const idInput = q('[name="id"]', form);
    showFormError(form, false);
    addItems(items, { button: btn, form, skipCart: !!(idInput && idInput.dataset.skipCart === 'true') });
  }, true);

  /* ------------------------------------------------------------------ init + theme editor */
  const init = (root) => placeSizingCharts(root);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:unload', (e) => {
    const id = e.detail && e.detail.sectionId;
    if (!id) return;
    qa(`hm-sticky-atc[data-section="${esc(id)}"], modal-dialog[data-hm-section="${esc(id)}"]`).forEach((el) => el.remove());
  });

  window.HMPB = { formatMoney, addItems, collectExtras };
})();
